import { env } from "@canucci/base/env";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRouter from "./routes";
import "./config/i18n";

if (env.MODE === "development") {
  import("./index.development.css");
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);

// Create a client with better defaults for development
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Canvas data can change (e.g., voting enabled), so don't cache too long
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
    },
  },
});

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  </StrictMode>,
);
